export default {
    GROSS_INVENTORY(state, items) {
        state.items = items
    }
}
